import { render } from "./TimiHeader.vue?vue&type=template&id=9cd8e2c6&ts=true"
import script from "./TimiHeader.vue?vue&type=script&lang=ts"
export * from "./TimiHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/timitools.webweb.works/client/timitools/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__